/**
 * Pure platform-detection helpers for the app-promo surfaces (#1465).
 * UA and display-mode are session-stable, so plain functions suffice — no hook/state needed.
 */

export const isAndroid = (): boolean => /Android/i.test(navigator.userAgent)

// iPadOS 13+ Safari reports a desktop Macintosh UA by default, so the plain UA regex
// misses iPads — disambiguate those via touch points.
export const isIOS = (): boolean =>
  /iPad|iPhone|iPod/i.test(navigator.userAgent) ||
  (/Macintosh/i.test(navigator.userAgent) && navigator.maxTouchPoints > 1)

// Standalone-PWA check (display-mode: standalone / navigator.standalone). Shared by main.tsx.
export const isStandalone = (): boolean =>
  window.matchMedia('(display-mode: standalone)').matches ||
  (navigator as Navigator & { standalone?: boolean }).standalone === true
